import { render, staticRenderFns } from "./CmgRewardExtrasCampaignCard.vue?vue&type=template&id=40b1a571&scoped=true&lang=pug&"
import script from "./cmg-reward-extras-campaign-card.ts?vue&type=script&lang=ts&"
export * from "./cmg-reward-extras-campaign-card.ts?vue&type=script&lang=ts&"
import style0 from "./CmgRewardExtrasCampaignCard.vue?vue&type=style&index=0&id=40b1a571&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b1a571",
  null
  
)

export default component.exports